import React, { useContext } from 'react'
import { Grid as Grid, List, Card, CardHeader, ListItem, ListItemText, Checkbox, Button, Divider, ListItemIcon, Tooltip, IconButton } from '@mui/material'

import { LoadingContext, M_Button } from '../../M_Components'
import { Delete } from '@mui/icons-material';
import { t } from 'i18next';
export function M_TransferList({ header, value, setValue, primaryColor,
    secondaryColor, entity, field, valueIdField, disabled, height
}) {
    const ctx = useContext(LoadingContext)

    primaryColor = primaryColor ? primaryColor : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    secondaryColor = secondaryColor ? secondaryColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'


    const getValues = (data) => {
        setValue(data)
    }


    const customList = (title, items, position) => (
        <Card sx={{
            borderRadius: '0px',
            boxShadow: '0px 0px 0px 0px',
            border: `1px solid ${disabled ? "var(--color-grey)" : primaryColor ? primaryColor : "var(--color-black)"}`,
            borderRadius: '5px',

        }}>
            <CardHeader
                titleTypographyProps={{ fontWeight: 'bold' }}
                sx={{ px: 2, py: 1, backgroundColor: 'var(--color-white)', borderBottom: `1px solid ${disabled ? "var(--color-grey)" : primaryColor ? primaryColor : "var(--color-black)"}`, color: disabled ? "var(--color-grey)" : secondaryColor ? secondaryColor : "var(--color-black)" }}
                action={
                    <div style={{ display: 'flex' }}>
                        {!disabled && <M_Button
                            tooltip={t('Edit')}
                            large
                            multiple
                            icon={<img src={'/icons/tableIcons/edit.svg'} alt={'Edit'} style={{ width: '20px', }} />}
                            onSubmitValue={getValues}
                            entity={entity}
                            value={value}
                            valueIdField={valueIdField}
                        />}
                        {/* <M_Button
                            icon={<img src={'/icons/tableIcons/edit.svg'} alt={'Edit'} style={{ color: 'pink', width: '20px', }} />}
                            onClick={() => { console.log('bruh') }}
                        /> */}
                    </div>
                }
                title={title}
            />
            <Divider />
            <List
                style={{
                    width: '100%  ',
                    height: height ? height : '500px',
                    color: disabled ? "var(--color-grey)" : "var(--color-black)",
                    backgroundColor: 'var(--color-white)',
                    overflow: 'auto',
                    paddingTop: '0px',
                    paddingBottom: '0px'
                }}
                dense
                component="div"
                role="list"
            >
                {items.map((obj, index) => {
                    return (
                        <ListItem
                            key={index}
                            role="listitem"
                            // onClick={handleToggle(value, position)}
                            style={{ cursor: disabled ? 'default ' : 'pointer' }}
                            secondaryAction={
                                !disabled && <IconButton
                                    sx={{
                                        color: 'var(--color-red)'
                                    }}
                                    edge="end"
                                    aria-label="delete"
                                    disableRipple
                                    onClick={() => { setValue(value.filter(objValue => objValue?.Id !== obj?.Id)) }}
                                    disabled={disabled}
                                >
                                    <Delete />
                                </IconButton>
                            }
                        >
                            <ListItemText primary={obj[field]} />
                        </ListItem>
                    )
                })}
            </List>
        </Card >
    )

    return (
        <Grid style={{ maxWidth: '300px', width: '100%' }}>
            <Grid>{customList(header, value, 'Left')}</Grid>
        </Grid >
    )
}